const URL_RE = /(https?:\/\/[^\s<]+[^\s<.,;:!?)\]'"])/g;

export default function Linkified({ text, className, testid }) {
  const parts = text.split(URL_RE);
  return (
    <p className={className} data-testid={testid}>
      {parts.map((p, i) => (i % 2 === 1 ? (
        <a key={i} href={p} target="_blank" rel="noopener noreferrer nofollow ugc" className="text-[#60A5FA] underline underline-offset-2 break-all">{p}</a>
      ) : p))}
    </p>
  );
}
